import { createApp, h } from 'vue';
import { VueMaskDirective } from 'v-mask';
import VueCookies from 'vue3-cookies';
import Notifications from '@kyvg/vue3-notification';
import App from './App';
import router from './router';
import store from './store';

// Vue.config.productionTip = false;

async function createAppData () {
  const app = createApp({ render: () => h(App) });

  app.directive('mask', VueMaskDirective);

  app.use(router);
  app.use(store);
  app.use(VueCookies);
  app.use(Notifications);

  app.mount('#app');
}

createAppData();
